<script setup>
import messages from '@/locales/messages.json'

const { locale } = useI18n()
const localeCookie = useCookie('LOCALE')

const allLocales = Object.keys(messages)
const updateLanguage = (code) => {
    localeCookie.value = code
    locale.value = code

    // reload the page
    window.location.reload()
}
</script>
<template>
    <v-menu location="top">
        <template v-slot:activator="{ props }" v-if="allLocales">
            <v-btn variant="text" dark v-bind="props" prepend-icon="mdi-translate">
                {{ locale }}
                <v-icon icon="mdi-menu-down"></v-icon>
            </v-btn>
        </template>
        <v-list v-if="allLocales">
            <v-list-item v-for="(lang, index) in allLocales" :key="'lang-' + index">
                <v-list-item-title class="lang-name" @click="updateLanguage(lang)">
                    {{ lang }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<style scoped>
.lang-name {
    cursor: pointer;
}
</style>
